<template>
  <div>
    <el-container>
      <el-header>
        <div class="header">
          <i class="icon icon-home" @click="$toIndex"></i>
          <i class="icon icon-01"></i>
          <i class="icon icon-02"></i>
          <i class="icon icon-03"></i>
          <i class="icon icon-04"></i>
          <el-button class="fr" type="primary" @click="$calculate">开始计算</el-button>
        </div>
      </el-header>
      <div class="project-box">
        <div class="left-nav">
          <div class="nav active">基础参数</div>
        </div>
        <div class="content-wrap">
          <el-row>
            <el-col :span="12">
              <span class="title">参数类型</span>
              <div v-for="(item, index) in coord" :key="index">
                <div class="point-title">坐标点{{index + 1}} (x,y)</div>
              </div>
            </el-col>
            <el-col :span="12">
              <span class="title text-right">
                <el-button type="primary" size="small" @click="$addCoord">添加坐标点</el-button>
              </span>
              <el-form>
                <div v-for="(item, index) in coord" :key="index">
                  <el-form-item>
                    <div class="point">
                      <el-input v-model.number="item[0]"></el-input>
                      <el-input v-model.number="item[1]"></el-input>
                      <i class="icon icon-delete" @click="$deleteCoord(index)"></i>
                    </div>
                  </el-form-item>
                </div>
              </el-form>
            </el-col>
          </el-row>
        </div>
        <div class="img-wrap">
          <img :src="imgSrc" alt="">
        </div>
      </div>
      <progress-dialog @complete="$complete"></progress-dialog>
    </el-container>
  </div>
</template>

<script>
import progressDialog from '../../components/common/progressDialog'

export default {
  name: 'project',
  components: {
    progressDialog
  },
  data() {
    return {
      coord: [['', ''], ['', '']],
      imgSrc: ''
    }
  },
  methods: {
    showUploadDialog(val) {
      this.$root.$emit('showUploadDialog', val)
    },
    $addCoord() {
      this.coord.push(['', ''])
    },
    $deleteCoord(index) {
      this.coord.splice(index, 1)
    },
    $calculate() {
      for (let i = 0; i < this.coord.length; i++) {
        if (!this.coord[i][0] && this.coord[i][0] !== 0) {
          this.$message({
            message: `请输入坐标点${i + 1} x的坐标`,
            type: 'warning'
          })
          return false
        }
        if (!this.coord[i][1] && this.coord[i][1] !== 0) {
          this.$message({
            message: `请输入坐标点${i + 1} y的坐标`,
            type: 'warning'
          })
          return false
        }
      }
      let coordConfig = [this.coord.length + '']

      this.coord.forEach(item => {
        coordConfig.push(item.join(','))
      })

      coordConfig = JSON.stringify(coordConfig)

      this.$api.startBuild({
        config: coordConfig
      }).then(({ data }) => {
        this.$root.$emit('showProgress', data.file)
      })
    },
    $complete(file) {
      if (file === 'show') {
        this.imgSrc = '/static/img/img-project.jpg'
      } else {
        this.imgSrc = file
      }
      this.$message({
        message: '计算完成',
        type: 'success'
      })
      // this.$confirm('请查看已经生成文件', '计算完成', {
      //   confirmButtonText: '查看',
      //   cancelButtonText: '取消',
      //   beforeClose: (action, instance, done) => {
      //     this.$router.push('/')
      //     done()
      //   }
      // }).then(action => {

      // })
    },
    $toIndex() {
      this.$router.push('/')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.el-header,
.el-footer {
  background: #2C2C2C;
  color: #333;
  font-size: 30px;
  line-height: 60px;
}

.project-box {
  background: #E5E5E5;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: space-between;

  .left-nav {
    width: 16.66%;
    overflow-y: auto;
    padding: 30px 0;
    background: #fff;

    .nav {
      font-size: 24px;
      line-height: 34px;
      color: #000000;
      padding: 8px 30px;
      transition: .2s all;
      cursor: pointer;
    }

    .active {
      background: #DAEBF7;
    }
  }
}

.el-col {
  margin-bottom: 20px;
  span.title {
    display: block;
    color: #3294f8;
    font-size: 18px;
    margin-bottom: 30px;
  }
}

.icon {
  display: block;
  width: 40px;
  height: 40px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-top: 10px;
  margin-left: 20px;
  margin-right: 20px;
  cursor: pointer;
  float: left;
  opacity: .7;
  transition: .2s all;
}

.icon:hover {
  opacity: 1;
}

.icon-home {
  background-image: url("/static/icon/icon-home.png");
}

.icon-01 {
  background-image: url("/static/icon/icon-01.png");
}

.icon-02 {
  background-image: url("/static/icon/icon-02.png");
}

.icon-03 {
  background-image: url("/static/icon/icon-03.png");
}

.icon-04 {
  background-image: url("/static/icon/icon-04.png");
}

.icon-delete {
  display: inline-block;
  width: 16px;
  height: 17px;
  background-image: url("/static/icon/icon-delete.png");
  float: none;
  margin-top: 0;
  margin-right: 0;
  margin-left: 0;
}

.header {
  overflow: hidden;

  .el-button {
    margin-top: 10px;
    float: left;
    margin-left: 20px;
  }

  .fr {
    float: right;
  }
}

.content-wrap {
  width: 31.25%;
  padding: 30px 20px 30px 30px;
  background: #fff;
  box-sizing: border-box;

  .point-title {
    font-size: 16px;
    line-height: 40px;
    color: #000000;
    margin-bottom: 22px;
  }

  .point {
    display: flex;
    align-items: center;

    .el-input {
      width: 40%!important;
      margin-right: 10px;
    }
  }
}

.img-wrap {
  width: 50%;
  background: #fff;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/project/project.vue